import React, { Component } from "react";
import { get } from "lodash";
import { formatNumber, isValidArray, GROUP_KEYS } from "../../helper";
import { Row, Col } from "react-bootstrap";
import { ca } from "date-fns/locale";

const fields = {
  "170": ["project_cost_share", "geo_coordinates", "population_benefitted"],
  "150": ["geo_coordinates"]
};
const fieldsStatePMG = ["geo_coordinates"];
export class ProjectDetailsExtension extends Component {
  renderStateSpecificFields = fieldName => {
    const { data } = this.props;
    switch (fieldName) {
      case "project_cost_share":
        return (
          <Row>
            <Col lg={5}>Project Cost Share (in crores)</Col>
            <Col lg={7}>
              <div>
                <div>
                  Central Share - {"\u20B9"}{" "}
                  {formatNumber(get(data, "centralCost"))} Cr.
                </div>
                <div>
                  State Share - {"\u20B9"}{" "}
                  {formatNumber(get(data, "stateCost"))} Cr.
                </div>
              </div>
            </Col>
          </Row>
        );
        break;

      case "geo_coordinates":
        return (
          get(data, "geoCoordinates") && (
            <Row>
              <Col lg={5}>Geo Coordinates</Col>
              <Col className="geo-coordinates-success-page" lg={7}>
                {get(data, "geoCoordinates", "NA")}
              </Col>
              {get(data, "projectExtensionFiles") &&
              isValidArray(get(data, "projectExtensionFiles")) ? (
                <>
                  <Col lg={5} />
                  <Col
                    className="pt-0 d-flex flex-wrap geo-coordinates-attachment"
                    lg={7}
                  >
                    {get(data, "projectExtensionFiles", []).map(
                      (file, index) => {
                        const extension = file.name.substr(
                          file.name.lastIndexOf(".") + 1,
                          file.name.length
                        );
                        const name = file.name.substr(
                          0,
                          file.name.lastIndexOf(".")
                        );

                        return (
                          <div className="project-download-icons">
                            <div className="download-icons-pdf">
                              {extension}
                            </div>
                            <a
                              role="button"
                              download={get(file, "name", "NA")}
                              href={get(file, "s3Url", "NA")}
                              target={get(file, "name", "NA")}
                            >
                              {name}
                            </a>
                          </div>
                        );
                      }
                    )}
                  </Col>
                </>
              ) : null}
            </Row>
          )
        );
        break;

      case "population_benefitted":
        return (
          get(data, "populationBenefitted") && (
            <Row>
              <Col lg={5}>Population Benefitted</Col>
              <Col lg={7}>{get(data, "populationBenefitted", "NA")}</Col>
            </Row>
          )
        );
        break;
    }
  };

  render() {
    const { sponsoredByid, fieldName, sponsoredByCategory } = this.props;

    if (
      !Object.keys(fields).includes(sponsoredByid) &&
      sponsoredByCategory === GROUP_KEYS.STATE
    ) {
      if (fieldsStatePMG.includes(fieldName)) {
        return this.renderStateSpecificFields(fieldName);
      }
    }

    if (!fields[sponsoredByid]) {
      return null;
    }

    if (!fields[sponsoredByid].includes(fieldName)) {
      return null;
    }

    return this.renderStateSpecificFields(fieldName);
  }
}
